// The token BP (spec_20261103 C6): 10% of SP rounded down to the pound, plus £1. Prices in
// pounds. One definition for the pricing engine (offer-rule.js) and the quote page (tokenCheck.js).
export const tokenBp = (sp) => Math.floor(sp / 10) + 1;
